import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'highlight',
    standalone: false
})
export class HighlightPipe implements PipeTransform {
  transform(value: string, keyword: string): string {
    if (!value || !keyword) return value;
    const regex = new RegExp(`(${keyword})`, 'gi'); // Buscar la palabra clave (case-insensitive)
    return value.replace(
      regex,
      '<span class="text-red-900 font-bold text-2xl">$1</span>'
    );
  }
}
